export enum VersioningStatusEnum {
  PUBLISHED = 'PUBLISHED',
  EDITING = 'EDITING',
  DISABLED = 'DISABLED',
  BETA = 'BETA',
  VERSIONING = 'VERSIONING',
}

export enum VersioningStatusUIEnum {
  DRAFT = 'DRAFT',
  VERSIONING = VersioningStatusEnum.VERSIONING,
  PUBLISHED = VersioningStatusEnum.PUBLISHED,
  EDITING = VersioningStatusEnum.EDITING,
  BETA = VersioningStatusEnum.BETA,
  DISABLED = VersioningStatusEnum.DISABLED,
}

export type StudioAction =
  | 'editing'
  | 'versioning'
  | 'beta'
  | 'published'
  | 'disabled';

export const versioningStatusActions: Record<
  VersioningStatusEnum,
  StudioAction
> = {
  [VersioningStatusEnum.EDITING]: 'editing',
  [VersioningStatusEnum.VERSIONING]: 'versioning',
  [VersioningStatusEnum.BETA]: 'beta',
  [VersioningStatusEnum.PUBLISHED]: 'published',
  [VersioningStatusEnum.DISABLED]: 'disabled',
};

export const studioActions: Record<StudioAction, VersioningStatusEnum> = {
  editing: VersioningStatusEnum.EDITING,
  versioning: VersioningStatusEnum.VERSIONING,
  beta: VersioningStatusEnum.BETA,
  published: VersioningStatusEnum.PUBLISHED,
  disabled: VersioningStatusEnum.DISABLED,
};

export type StudioPermissions = {
  allowFirstStep: boolean;
  allowOtherSteps: {
    createEditing: boolean;
    simpleEditing: boolean;
    advancedEditing: boolean;
  };
};
